import { render, staticRenderFns } from "./Gracias.vue?vue&type=template&id=3d422580&scoped=true"
import script from "./Gracias.vue?vue&type=script&lang=js"
export * from "./Gracias.vue?vue&type=script&lang=js"
import style0 from "./Gracias.vue?vue&type=style&index=0&id=3d422580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d422580",
  null
  
)

export default component.exports